import { render, staticRenderFns } from "./EventHistoryActivitySummary.vue?vue&type=template&id=65de226c&scoped=true&"
import script from "./EventHistoryActivitySummary.vue?vue&type=script&lang=js&"
export * from "./EventHistoryActivitySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de226c",
  null
  
)

export default component.exports